import { CommonResponse } from "@gtpl/shared-models/masters";
import { Body, Controller, Get, Param, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { PayrollProcessService } from "./payroll-process.service";
import { PayrollComponentsDto } from "./dto/payroll-process.dto";
import { PayrollChildDto } from "./dto/payroll-process-child.dto";
import { EmployeeIdReq } from "./dto/employee-id.req";
import { PayRollMonthDto, PayRollRequest } from "@gtpl/shared-models/hrms";
import { MailerService } from "./send-mail";
import { employeeIdRequest } from "@gtpl/shared-models/gtpl";

@Controller('payroll')
@ApiTags('payroll')
export class PayrollProcessController {
    constructor(
        private payrollProcessService: PayrollProcessService,
        private readonly mailService : MailerService

    ) {

    }

    @Post("/createPayroll")
    // @ApiBody({ type:  PayrollComponentsDto })
    async createPayroll(@Body() createDto: PayrollComponentsDto): Promise<CommonResponse> {
        try {
            return this.payrollProcessService.createPayroll(createDto);
        } catch (error) {
            return new CommonResponse(false, 11111, error);
        }
    }

    @Post('/generatePayRoll')
    @ApiBody({ type: PayRollRequest })
    async generatePayRoll(@Body() req: any): Promise<CommonResponse> {
        try {
              return await this.payrollProcessService.generatePayRoll(req);
        } catch (error) {
            throw error
        }
    }
    @Post('/getPayrollComponentsData')
    async getPayrollComponentsData(): Promise<CommonResponse> {
        try {
            return this.payrollProcessService.getPayrollComponentsData();
        } catch (error) {
            return new CommonResponse(false, 11111, error);

        }
    }


    @Post('/saveEmployeePayrollComponent')
    async saveEmployeePayrollComponent(@Body() reqObj:any): Promise<CommonResponse> {
        try {
            return this.payrollProcessService.saveEmployeePayrollComponent(reqObj);
        } catch (error) {
            return new CommonResponse(false, 11111, error);

        }
    }

    @Post('/DeductionExcelUpload')
    async DeductionExcelUpload(@Body() data:any): Promise<CommonResponse>{
        try{
         return this.payrollProcessService.DeductionExcelUpload(data);
        } catch (error) {
            return new CommonResponse(false, 11111, error);

        }
     }
     
    @Post('/getAllPayrollLogs')
    async getAllPayrollLogs(@Body() req: PayRollMonthDto): Promise<CommonResponse>{
        try{
         return this.payrollProcessService.getAllPayrollLogs(req);
        } catch (error) {
            return new CommonResponse(false, 11111, error);

        }
     }



     @Post('/getDeductionsData')
     async getDeductionsData(): Promise<CommonResponse> {
         try {
             return this.payrollProcessService.getDeductionsData();
         } catch (error) {
             return new CommonResponse(false, 11111, error);
 
         }
     }


     @Post('/getPayrollLogByEmployeeId')
  @ApiBody({ type: EmployeeIdReq })
  async getPayrollLogByEmployeeId(@Body() req: any): Promise<CommonResponse> {
    try {
        return this.payrollProcessService.getPayrollLogByEmployeeId(req);
    } catch (error) {
        return new CommonResponse(false, 11111, error);

    }
}

@Post('/getEmployeeDataAgainstYearMonth')
async getEmployeeDataAgainstYearMonth(@Body() req: any): Promise<CommonResponse> {
    try {
        return this.payrollProcessService.getEmployeeDataAgainstYearMonth(req);
    } catch (error) {
        return new CommonResponse(false, 11111, error);

    }
}
    
     @Post('/getAllEmployeeEmployeeNamePayrollLogs')
     async getAllEmployeeEmployeeNamePayrollLogs(): Promise<CommonResponse>{
         try{
          return this.payrollProcessService.getAllEmployeeEmployeeNamePayrollLogs();
        } catch (error) {
            return new CommonResponse(false, 11111, error);

        }
    }
    
     @Post('/updateFreezeStatus')
     async updateFreezeStatus(@Body() req: PayRollMonthDto): Promise<CommonResponse> {
        console.log(req,'PayRollMonthDto')
         try {
             return this.payrollProcessService.updateFreezeStatus(req);
         } catch (error) {
             return new CommonResponse(false, 11111, error);
 
         }
      }

      @Post('/getAllNMREmployeeNamePayrollLogs')
      async getAllNMREmployeeNamePayrollLogs(): Promise<CommonResponse>{
          try{
           return this.payrollProcessService.getAllNMREmployeeNamePayrollLogs();
          } catch (error) {
              return new CommonResponse(false, 11111, error);
  
          }
       }

       @Post('/getAllInHouseEmployeeNamePayrollLogs')
       async getAllInHouseEmployeeNamePayrollLogs(): Promise<CommonResponse>{
           try{
            return this.payrollProcessService.getAllInHouseEmployeeNamePayrollLogs();
           } catch (error) {
               return new CommonResponse(false, 11111, error);
   
           }
        }
 


     @Post('/getPayrollAllData')
     async getPayrollAllData(@Body() req?: PayRollRequest): Promise<CommonResponse> {
         try {
             return await this.payrollProcessService.getPayrollAllData(req)
         } catch (error) {
            return new CommonResponse(false, 11111, error);

        }
     }

     @Post('/earningsExcelUpload')
     async earningsExcelUpload(@Body() data:any): Promise<CommonResponse>{
         try{
          return this.payrollProcessService.earningsExcelUpload(data);
         } catch (error) {
             return new CommonResponse(false, 11111, error);
 
         }
      }
 
     

      @Post('/getEarningsData')
     async getEarningsData(): Promise<CommonResponse> {
         try {
             return this.payrollProcessService.getEarningsData();
         } catch (error) {
             return new CommonResponse(false, 11111, error);
 
         }
     }

      @Post('/getTdsData')
     async getTdsData(): Promise<CommonResponse> {
         try {
             return this.payrollProcessService.getTdsData();
         } catch (error) {
             return new CommonResponse(false, 11111, error);
 
         }
     }

      @Post('/tdsExcelUpload')
     async tdsExcelUpload(@Body() data:any): Promise<CommonResponse> {
         try {
             return this.payrollProcessService.tdsExcelUpload(data);
         } catch (error) {
             return new CommonResponse(false, 11111, error);
 
         }
     }
    
     @Post('/sendPaySlipMail')
     async sendPaySlipMail(@Body() req: any): Promise<CommonResponse> {
       try {
         return await this.mailService.sendPaySlipMail(req);
       } catch (error) {
         console.log('----------error in send mail controller')
         console.log(error)
         console.log('-------End in Controller')
       }
     }
 
     @Post('/getEmpTransactionReport')
     async getEmpTransactionReport(@Body() req:employeeIdRequest): Promise<CommonResponse> {
         try {
             return this.payrollProcessService.getEmpTransactionReport(req);
         } catch (error) {
             return new CommonResponse(false, 11111, error);
 
         }
     }

     @Get('/getEmpInTransaction')
     async getEmpInTransaction(): Promise<CommonResponse> {
         try {
             return this.payrollProcessService.getEmpInTransaction();
         } catch (error) {
             return new CommonResponse(false, 11111, error);
 
         }
     }

}